// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/announcement-bar/announcement-bar';
import 'snippets/menu/menu';
import 'snippets/header-menu/header-menu';
//import 'snippets/country-switcher/country-switcher';
// import 'snippets/search-form/search';
// import 'snippets/predictive-search/predictive-search';
import 'snippets/icon/icon';

// Styles
import './_header.scss';

// Optional Features
// import './header--sticky';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const HEADER_CONTAINER_SELECTOR = '#shopify-section-header';
const HEADER_SELECTOR           = '.header';
const HAMBURGER_CLASS           = 'header__link--menu';
const HAMBURGER_SELECTOR        = '.header__link--menu';
const MENU_HEADER_LOGO          = '.header__link--logo';
const MENU_WRAPPER_SELECTOR     = '.header__nav-wrapper';
const MENU_ITEM_SELECTOR        = '.header-menu__item--dropdown';
const MENU_BUTTON_SELECTOR      = '.header-menu__button';
const CART_CONFIRMATION_MODAL_CONTENT_SELECTOR = '.modal--cart-confirmation .modal__content';
const CART_LINK_SELECTOR = '.header__link--cart';

// Classes
const OPEN_CLASS      = 'js--is-open';
const NO_SCROLL_CLASS = 'noscroll';
const SCROLLED_CLASS  = 'scrolled';


// -------------------------------------
// Helper functions
// -------------------------------------

// Open the menu
function openMenu(menu) {
    menu.$body.classList.add(NO_SCROLL_CLASS);
    menu.$header.classList.add(OPEN_CLASS);

    if(menu.$hamburger != null) {
        menu.$hamburger.classList.add(OPEN_CLASS);
        menu.$hamburger.setAttribute('aria-expanded', 'true');
    }
}

// Close the menu
function closeMenu(menu) {
    if(menu != null) {
        if(menu.$body != null) {
            menu.$body.classList.remove(NO_SCROLL_CLASS);
        }
        if(menu.$header != null) {
            menu.$header.classList.remove(OPEN_CLASS);
        }
        if(menu.$hamburger != null) {
            menu.$hamburger.classList.remove(OPEN_CLASS);
            menu.$hamburger.setAttribute('aria-expanded', 'false');
        }
        if(menu.$items != null) {
            removeClassFromElements(menu.$items, OPEN_CLASS);
        }
        if(menu.$buttons != null) {
            setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
        }
    }
}

// Remove a given class from a list of elements
function removeClassFromElements(elems, className) {
    elems.forEach(function(elem, index) {
        if(elem != null) {
            elem.classList.remove(className);
        }
    });
}

// Set the value of a given attribute for a list of elements
function setAttributeForElements(elems, attribute, value) {
    elems.forEach(function(elem) {
        if(elem != null) {
            elem.setAttribute(attribute, value);
        }
    });
}

function handleScroll(element) {
    const scrolled = window.scrollY > 30;
    const scrolledToTop = window.scrollY === 0;

    if (scrolled) {
        element.classList.add(SCROLLED_CLASS);
    }

    if (scrolledToTop) {
        element.classList.remove(SCROLLED_CLASS);
    }
}

function isHamburgerClick(target) {
    return target.classList.contains(HAMBURGER_CLASS) || target.closest(HAMBURGER_SELECTOR) !== null;
}

function isMenuWrapperOrModalContent(target) {
    return target.closest(MENU_WRAPPER_SELECTOR) !== null
        || target.closest(CART_CONFIRMATION_MODAL_CONTENT_SELECTOR) !== null
        || target.closest(CART_LINK_SELECTOR) !== null;
}

function openOrCloseMenu(menu) {
    if (menu.$hamburger.classList.contains(OPEN_CLASS)) {
        closeMenu(menu);
    } else {
        openMenu(menu);
    }
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    const menu = {
        $body: document.querySelector('body'),
        $header: document.querySelector(HEADER_SELECTOR),
        $headerLogo: document.querySelector(MENU_HEADER_LOGO),
        $hamburger: document.querySelector(HAMBURGER_SELECTOR),
        $items: document.querySelectorAll(MENU_ITEM_SELECTOR),
        $buttons: document.querySelectorAll(MENU_BUTTON_SELECTOR),
        $menuLinks: document.querySelectorAll('.header-menu__link'),
    };

    menu.$body.addEventListener('click', function(event) {
        const $this = event.target;
        if (isHamburgerClick($this)) {
            event.preventDefault();
            openOrCloseMenu(menu);
        } else if (!isMenuWrapperOrModalContent($this)) {
            closeMenu(menu);
        }
    });

    menu.$body.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
            closeMenu(menu);
        }
    });
});


document.addEventListener('scroll', function() {
    const headerContainerSelector   = document.querySelector(HEADER_CONTAINER_SELECTOR);

    if (headerContainerSelector !== null) {
        handleScroll(headerContainerSelector);

        // var   st              = document.documentElement.scrollTop;
        // const noScrollBody    = document.querySelector('body.noscroll');

        // if (st > lastScrollTop || st == 0) { // If scrolling down
        //     headerContainerSelector.classList.add(SCROLLED_CLASS);
        // } else if (st < lastScrollTop) { // If scrolling up
        //     // headerContainerSelector.classList.remove(SCROLLED_CLASS);
        // }
        // lastScrollTop = st <= 0 ? 0 : st;
    }
});
